import { PixelShader } from 'three/examples/jsm/shaders/PixelShader.js';
//import { ToonShader1, ToonShader2, ToonShaderHatching, ToonShaderDotted } from 'three/examples/jsm/shaders/ToonShader.js';
import { GrayScaleShader } from './GrayScaleShader.js'
import { RandomNoiseShader } from './RandomNoiseShader.js'
import { LinesShader } from './LinesShader.js'
import { RGBSplit } from './RGBSplit.js'
import { HorizontalFlip } from './HorizontalFlip.js'
import { ToonShader } from './ToonShader.js'
import { SobelEdgeShader } from './SobelEdgeShader.js'
import { SharpnessShader } from './SharpnessShader.js'
import { BaseColorLightness } from './BaseColorLightness.js'
import { BleachBypassShader } from 'three/examples/jsm/shaders/BleachBypassShader.js';
import { BrightnessContrastShader } from 'three/examples/jsm/shaders/BrightnessContrastShader.js';
import { ColorifyShader } from 'three/examples/jsm/shaders/ColorifyShader.js';
//import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js';
//import { HalftoneShader } from 'three/examples/jsm/shaders/HalftoneShader.js';
import { HorizontalBlurShader } from 'three/examples/jsm/shaders/HorizontalBlurShader.js';
import { HueSaturationShader } from 'three/examples/jsm/shaders/HueSaturationShader.js';
import { KaleidoShader } from 'three/examples/jsm/shaders/KaleidoShader.js';
import { LuminosityShader } from 'three/examples/jsm/shaders/LuminosityShader.js';
//import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js';
import { SepiaShader } from 'three/examples/jsm/shaders/SepiaShader.js';
//import { TechnicolorShader } from 'three/examples/jsm/shaders/TechnicolorShader.js';
//import { UnpackDepthRGBAShader } from 'three/examples/jsm/shaders/UnpackDepthRGBAShader.js';
//import { VignetteShader } from 'three/examples/jsm/shaders/VignetteShader.js';
import { VerticalBlurShader } from 'three/examples/jsm/shaders/VerticalBlurShader.js';
//import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader.js';
import { DotScreenShader } from 'three/examples/jsm/shaders/DotScreenShader.js';

function removeExcludedUniforms(uniforms) {
    var result = {...uniforms};

    for (var key in result) {
        if (Object.prototype.hasOwnProperty.call(result, key)) {
            if (ExcludedUniforms.includes(key)) {
                delete result[key];
            }
        }
    }

    return result;
}

var ExcludedUniforms = ['time', 'resolution', 'tDiffuse', 'uDirLightPos'];
var AvailableShaders = [
    //{ title: "Sobel Operator", type: SobelOperatorShader }, //Don't Use it, adds a black background
    { group_title: "Recommended", group_members: [
        { title: "Toon", description: "Toon your screen", type: ToonShader },
        { title: "Pixelate", description: "Let there be pixelart!", type: PixelShader },
        { title: "RGB Split", description: "Split the RGB!", type: RGBSplit },
        { title: "Hue Saturation", description: "Control the hue and saturation", type: HueSaturationShader },
        { title: "Soble Edge", description: "Add edges to your screen", type: SobelEdgeShader },
        { title: "Sharpness", description: "Sharpen the image", type: SharpnessShader },
    ] },
    { group_title: "Colors", group_members: [
        { title: "Base Color Lightness", description: "Set the lightness level of the base colors", type: BaseColorLightness },
        { title: "Brightness Contrast", description: "Control the brightness and the contrast", type: BrightnessContrastShader},
        { title: "Bleach Bypass", description: "Bleach bypass?", type: BleachBypassShader},
        { title: "Dot Screen", description: "Add dots to the screen?", type: DotScreenShader },
        { title: "Sepia", description: "Sepia color your screen", type: SepiaShader },
        { title: "Colorify", description: "Colorify the screen", type: ColorifyShader },
        { title: "Gray Scale", description: "Turn things gray", type: GrayScaleShader},
        { title: "Luminosity", description: "Luminosity?", type: LuminosityShader },
    ] },
    { group_title: "Textures", group_members: [
        { title: "Random Noise", description: "Random noise texture", type: RandomNoiseShader },
        { title: "Lines", description: "Lines texture", type: LinesShader },
    ] },
    { group_title: "Blur", group_members: [
        { title: "Vertical Blur", description: "Vertically blur the screen", type: VerticalBlurShader },
        { title: "Horizontal Blur", description: "Blur horizontally", type: HorizontalBlurShader },
    ] },
    { group_title: "Misc & Weird", group_members: [
        { title: "Kaleido", description: "A girl with koleidoscope eyes", type: KaleidoShader },
        { title: "Horizontal Flip", description: "Flip the screen horizontally", type: HorizontalFlip},
        //{ title: "Gamma Correction", description: "Correct the gamma", type: GammaCorrectionShader },
    ] },
    //{ title: "Toon Shader 1", type: ToonShader1 },
    //{ title: "Toon Shader 2", type: ToonShader2 },
    //{ title: "Toon Shader Hatching", type: ToonShaderHatching },
    //{ title: "Toon Shader Dotted", type: ToonShaderDotted },
    //{ title: "Halftone", description: "", type: HalftoneShader },

    //{ title: "RGB Shift", description: "Shift your RGB to the next level", type: RGBShiftShader }, //Don't Use it, has a problem with the alpha channel for the r and b.
    //{ title: "Technicolor", description: "???", type: TechnicolorShader }, //Don't use it, adds a black background
    //{ title: "Unpack Depth RGBA", description: "???", type: UnpackDepthRGBAShader },
    //{ title: "Vignette", description: "", type: VignetteShader },
];

PixelShader.uniforms.pixelSize.value = 5;
for (let i = 0; i < AvailableShaders.length; i++) {
    let group = AvailableShaders[i];
    //console.log("Here", group);
    for (let j = 0; j < group.group_members.length; j++) {
        let shader = group.group_members[j];
        //console.log(shader);
        if (typeof shader == 'string') {
            continue;
        }

        shader.uniforms = removeExcludedUniforms(shader.type.uniforms);
        shader.defaultUniforms = removeExcludedUniforms(shader.type.uniforms);
    }
}

export { AvailableShaders, ExcludedUniforms };
